module.exports = __webpack_public_path__ + "img/pc.1cd719f0.webp";